"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOTApply = void 0;
const engine_1 = require("../../../../../engine");
// TODO: delete here's any @kailang
const JOTApply = (state, { payload }, filterCB) => {
    const max = 10000;
    let pureJOTAction = payload.operations.reduce((pre, op) => {
        const length = op.actions.length;
        if (length > max) {
            for (let i = 0, divides = Math.ceil(length / max); i < divides; i++) {
                pre.push(...op.actions.slice(i * max, (i + 1) * max));
            }
        }
        else {
            pre.push(...op.actions);
        }
        return pre;
    }, []);
    if (filterCB) {
        pureJOTAction = filterCB(state, pureJOTAction);
    }
    engine_1.jot.apply(state.snapshot, pureJOTAction);
    return state;
};
exports.JOTApply = JOTApply;
//# sourceMappingURL=jot_apply.js.map